/**
 * Status-afleiding voor de UI: wat ziet de gebruiker en waarom.
 */

import { getCurrentServe, getSideSwitchStatus, playerNameAtOrderPosition, type MatchState } from "../core";

export interface StatusInfo {
  label: string;
  tone: "ok" | "warn" | "ask" | "info" | "match";
}

export function statusInfo(state: MatchState): StatusInfo {
  if (state.matchWinner) {
    return { label: `Wedstrijd gewonnen door ${state.config.teams[state.matchWinner].name}`, tone: "match" };
  }
  if (state.phase === "set_over") {
    const w = state.currentSet.winner;
    return { label: w ? `Set ${state.setNumber} gewonnen door ${state.config.teams[w].name}` : "Set afgelopen", tone: "ok" };
  }
  const r = state.rally;
  if (!r) {
    return state.phase === "awaiting_first_serve"
      ? { label: "Wacht op eerste opslag", tone: "info" }
      : { label: "Wacht op opslag", tone: "info" };
  }
  switch (r.result?.status ?? null) {
    case "provisional":
      return { label: "Voorlopig punt — volgende opslag bevestigt/corrigeert", tone: "warn" };
    case "proposal":
      return { label: "Voorstel — bevestig of wacht", tone: "ask" };
    case "unknown":
      return { label: "Rally onduidelijk — opslag of één tik beslist", tone: "ask" };
    case "confirmed":
      return { label: "Punt bevestigd", tone: "ok" };
  }
  switch (r.phase) {
    case "serve_candidate":
      return { label: "Opslag gedetecteerd", tone: "info" };
    case "rally_active":
      return { label: "Rally actief", tone: "info" };
    case "rally_end_candidate":
      return { label: "Rally geëindigd — resultaat volgt", tone: "info" };
    case "result_uncertain":
      return { label: "Resultaat onzeker", tone: "ask" };
    default:
      return { label: r.phase, tone: "info" };
  }
}

/** Wie serveert nu / verwacht (voor de weergave op het live scherm). */
export function servingDisplay(state: MatchState): { teamLabel: string; player: string; sideLabel: string; note: string } | null {
  const serve = state.rally ? getCurrentServe(state) : state.nextServe;
  if (!serve) return null;
  const team = state.config.teams[serve.team];
  const player = playerNameAtOrderPosition(state, serve.team, serve.playerIndex);
  const side = state.rally?.serve?.side ?? state.physicalSides[serve.team];
  const sideLabel = side === "left" ? "links" : side === "right" ? "rechts" : "?";
  return {
    teamLabel: team.name,
    player,
    sideLabel,
    note: serve.playerIndex === 0 ? "eerste serveerder (volgorde)" : "tweede serveerder (volgorde)",
  };
}

export function sideSwitchPending(state: MatchState): number {
  return getSideSwitchStatus(state).pending;
}
